<template>
	<b-row>
		<b-col cols="12">
			<LoanEligibilityCalculator ref="loan_eligibility" :is-view-only="isViewOnly" />
		</b-col>
	</b-row>
</template>

<script>
import LoanEligibilityCalculator from '@/views/CustomerProfile/CenterComponents/LoanEligible/LoanEligibilityCalculator'

export default {
	props: ['is-view-only'],
	components: {
		LoanEligibilityCalculator
	}
}
</script>